import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { Context } from 'src/app/context';
import { BrandModel } from 'src/app/models/brand.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  logoUrl: string = `${environment.baseUrl}/images/logo`;
  brand: BrandModel;
  showBackButton = false;

  constructor(
    private location: Location,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.brand = Context.brand;

    this.updateBackButton(this.router.url);
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe(event => this.updateBackButton(event.urlAfterRedirects));
  }

  private updateBackButton(url: string) {
    const path = url.split(/[?#]/, 1)[0].replace(/\/+$/, '') || '/';
    this.showBackButton = path !== '/tabs/home' && path !== '/';
  }

  goBack() {
    this.location.back();
  }

}
